(() => {
  const sections = document.querySelectorAll('[data-faq-search-results]');
  if (!sections.length) return;

  sections.forEach((results) => {
    const section = results.closest('[id^="shopify-section-"]') || results.closest('.shopify-section') || document;
    const input = section.querySelector('[data-faq-search-input]');
    const overlay = section.querySelector('.faq_search-overlay');
    const list = section.querySelector('[data-faq-search-list]');
    if (!input || !list) return;

    let data = [];
    const jsonScript = section.querySelector('[data-faq-questions-json]');
    const jsonText = jsonScript ? jsonScript.textContent : results.dataset.faqQuestions;
    try {
      data = JSON.parse(jsonText || '[]');
    } catch (error) {
      data = [];
    }

    const shopUrl = results.dataset.faqShopUrl || window.location.origin;
    const normalize = (value) => value.toLowerCase().trim();
    const clearResults = () => {
      list.innerHTML = '';
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };
    const setActive = (isActive) => {
      section.classList.toggle('faq-search--active', isActive);
    };
    const renderResults = (items) => {
      list.innerHTML = items
        .map((item) => {
          const handle = item.handle || '';
          const href = handle ? `${shopUrl}/pages/faq/${handle}` : '#';
          return `<li class="faq_search-results__item" role="option"><a class="faq_search-results__link" href="${href}">${item.title}</a></li>`;
        })
        .join('');
      results.hidden = items.length === 0;
      input.setAttribute('aria-expanded', items.length > 0 ? 'true' : 'false');
    };

    const handleInput = () => {
      const term = normalize(input.value);
      if (!term) {
        clearResults();
        return;
      }
      const matches = data.filter((item) => {
        const title = normalize(item.title || '');
        return title.includes(term);
      });
      renderResults(matches);
    };

    input.addEventListener('input', handleInput);
    input.addEventListener('focus', () => setActive(true));
    input.addEventListener('blur', () => {
      if (!section.contains(document.activeElement)) {
        setActive(false);
      }
    });
    if (overlay) {
      overlay.addEventListener('click', () => {
        input.blur();
        clearResults();
        setActive(false);
      });
    }
    document.addEventListener('click', (event) => {
      if (!section.contains(event.target)) {
        clearResults();
        setActive(false);
      }
    });
  });
})();
